import {
  browser,
  deviceTypes,
  pageCluster,
  rumArray,
  userTimingArray,
} from "../config/filter-list";
import * as toggle from "@otto-ec/global-resources/toggle";

/**
 *
 */
export const metricPrefix = "rum_";

export const TOGGLE_SEND_TO_ELK = "bs_send_extended_data_to_elk";

export enum METRIC_TYPE {
  rum,
  userTiming,
}

/*               */
export type RawUserTimingData = Record<string, number>;

/*                                                                       */
export type RawRumData = Record<string, string | number | boolean>;

export interface IMetric {
  metricName: string;
  value: number;
}

/*                                                                 */
export interface RumData {
  beaconType: string;
  deviceBrowser: string;
  deviceOS: string;
  pageCluster: string;
  requestTime: number;
  rumMetrics: IMetric[];
  rum_deviceType: string;
  rum_domComplete: number;
  rum_loadTime?: number;
  /*                                                                          */
  rum_sfid?: string;
  url?: string;
}

/*                                                                        */
export interface UserTimingData {
  beaconType: string;
  deviceBrowser: string;
  deviceOS: string;
  pageCluster: string;
  requestTime: number;
  rumMetrics: IMetric[];
  rum_deviceType: string;
  rum_supportsTouch: boolean;
  /*                                                                          */
  rum_sfid?: string;
  url?: string;
}

/**
 *
 *
 *
 *
 *
 */
export const isNotEmptyObject = <T>(value: T): value is NonNullable<T> =>
  value &&
  typeof value === "object" &&
  !Array.isArray(value) &&
  Object.keys(value).length > 0;

/**
 *
 */
export const isToggleActive = (toggleName: string): boolean =>
  toggle.get(toggleName, false);

/**
 *
 */
export const beaconServicePath = "/quality-beacon-service/";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function sendValidBeacon(
  dataObject: RumData | UserTimingData | undefined,
  endpoint: string,
  toggleName: string,
  metricType: METRIC_TYPE,
): void {
  if (
    isNotEmptyObject(dataObject) &&
    isToggleActive(toggleName) &&
    isRequiredDataCorrectlySet(dataObject, metricType)
  ) {
    navigator.sendBeacon(endpoint, JSON.stringify(dataObject));
  }
}

/**
 *
 */
export function capitalizeFirstLetterAfterPrefix(given: string): string {
  const data = given.startsWith(metricPrefix)
    ? { idx: metricPrefix.length, prefix: metricPrefix }
    : { idx: 0, prefix: "" };

  return data.prefix + capitalizeFirstLetter(given.slice(data.idx));
}

const capitalizeFirstLetter = (given: string): string =>
  given.charAt(0).toUpperCase() + given.slice(1);

export const prefixMetricKey = (metricKey: string): string =>
  metricKey.startsWith(metricPrefix)
    ? metricKey
    : `${metricPrefix}${metricKey}`;

export const capitalizeAndPrefixKeys = (rumData: RawRumData): RawRumData =>
  transformObject(rumData, (entries) =>
    entries.map(([key, value]) => [
      prefixMetricKey(capitalizeFirstLetterAfterPrefix(key)),
      value,
    ]),
  );

export function containsOnlyWhitelistedMetrics(
  data: RumData | UserTimingData,
  metricType: METRIC_TYPE,
): boolean {
  if (!data?.rumMetrics) {
    return false;
  }

  const allowedMetricNames =
    metricType === METRIC_TYPE.rum ? rumArray : userTimingArray;

  return (
    data.rumMetrics.length !== 0 &&
    data.rumMetrics.every((metric) =>
      allowedMetricNames.includes(metric.metricName),
    )
  );
}

export const isRequiredDataCorrectlySet = (
  data: RumData | UserTimingData,
  metricType: METRIC_TYPE,
): boolean =>
  browser.includes(data.deviceBrowser) &&
  pageCluster.includes(data.pageCluster) &&
  deviceTypes.includes(data.rum_deviceType) &&
  containsOnlyWhitelistedMetrics(data, metricType);

/**
 *
 *
 *
 *
 *
 */
export const filterByAllowedNames = (
  data: RawRumData,
  allowedValues: string[],
): RawRumData[] =>
  Object.entries(data)
    .filter(([metricName]) => allowedValues.includes(metricName))
    .map(([metricName, value]) => ({ metricName: metricName, value: value }));

/**
 *
 *
 *
 *
 *
 */
export function normalizeBrowser(
  rawBrowser: string | number | boolean,
): string {
  if (!rawBrowser || typeof rawBrowser !== "string") {
    return "undefined";
  }

  if (window.o_apps?.runningInApp?.()) {
    return "App_WebView";
  }

  return rawBrowser.replace(" ", "");
}

/**
 *
 *
 *
 *
 *
 */
export const transformObject = <T, R>(
  input: T,
  transformEntries: (
    entries: [key: keyof T, T[keyof T]][],
  ) => [keyof R, R[keyof R]][],
): R => Object.fromEntries(transformEntries(Object.entries(input))) as R;
